import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material/styles/createTheme';
import { MAX_PAGE_HEIGHT } from '../../styles/constants';

export const useStyles = makeStyles<Theme>()((theme) => ({
  resetPasswordWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: MAX_PAGE_HEIGHT,
  },
  resetPasswordContentWrapper: {
    borderRadius: '4px',
    backgroundColor: theme.palette.background.paper,
    width: '480px',
    padding: '16px',
  },
  resetPasswordForm: {
    width: '100%',
  },

  backToLogin: {
    textAlign: 'center',
    width: '100%',
    marginTop: '32px',
    fontWeight: 400,
    fontSize: '12px',
  },
  resetPasswordSubmitButton: {
    marginTop: '32px',
  },
  backToLoginButton: {
    cursor: 'pointer',
    color: theme.palette.primary.main,
    marginLeft: '4px',
  },
  textField: {
    '&:not(:first-of-type)': {
      marginTop: '16px',
    },
  },
}));
